

function Links() {
  return <div className="main-wrapper">
    
      

      <h1>Weiterführende Links</h1>

      <h3>
        Contact Improvisation
      </h3>

      <a href="https://contactjam-muenchen.de" target="_blank" rel="noopener noreferrer">
        contactjam-muenchen.de
      </a>

      <h3>
        ContacTango
      </h3>

      <a href="https://contangomuenchen.de" target="_blank" rel="noopener noreferrer">
        contangomuenchen.de
      </a>

      <h3>
        Feldenkrais
      </h3>

      <a href="https://innere-bewegung.de" target="_blank" rel="noopener noreferrer">
        innere-bewegung.de
      </a>

      <h3>
        Freier Kreativer Tanz & Tanzmeditation (Präsenz-Workshops und Online-Angebote)
      </h3>

      <a href="https://soul-dance-move.de" target="_blank" rel="noopener noreferrer">
        soul-dance-move.de
      </a>

      <h3>
        Holistische Tanz- und Bewegungstherapie (TherapeutInnen-Netzwerk)
      </h3>

      <a href=" https://holistische-tanztherapie.de" target="_blank" rel="noopener noreferrer">
        holistische-tanztherapie.de
      </a>

      <h3>
        Seminarhaus
      </h3>

      <a href="https://zentrum-lilie.de" target="_blank" rel="noopener noreferrer">
        zentrum-lilie.de
      </a>

      <h3>
        Tango Argentino, Patrizia & Michael Kronthaler
      </h3>

      <a href="https://tango-x.de" target="_blank" rel="noopener noreferrer">
        tango-x.de
      </a>

      <h3>
        zibko, Zentrum „In BeWEGung kommen", Barbara Hundshammer
      </h3>

      <a href="https://zibko.de" target="_blank" rel="noopener noreferrer">
        zibko.de
      </a>

    </div>
}
export default Links;